import { useBookingContext } from '../../contexts/BookingContext';

interface EditAppointmentButtonProps {
	getLabel: (key: string) => string;
}

export default function EditAppointmentButton({ getLabel }: EditAppointmentButtonProps) {
	const { appointment } = useBookingContext();

	return (
		<button type="button" onClick={appointment.edit} title={getLabel('edit_appointment_button')} data-testid="edit-appointment">
			{getLabel('edit_appointment_button')}
		</button>
	);
}
